import styled from 'styled-components';

import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';

export const CalculatorBlock = styled.div`
    background-color: ${promoColors.white};
    padding: 32px 24px;
    border-radius: 24px;
    flex-shrink: 0;
    margin-top: 16px;
    box-sizing: border-box;

    ${promoMedia.tablet744} {
        padding: 32px;
        margin-top: 24px;
    }

    ${promoMedia.desktop1440} {
        padding: 48px 32px 56px 32px;
        margin-left: 40px;
        margin-top: 0;
        width: 520px;
    }
`;
export const CalculatorRow = styled.div`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 32px;

        ${promoMedia.desktop1440} {
            margin-bottom: 48px;
        }
    }
`;
export const ButtonContainer = styled.div`
    margin-top: 48px;
    text-align: center;
    position: static;
    height: auto;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
`;
